import { TButtonOption } from '../../../types/options';

export const getPaddingPostfix = (hasIcon: boolean, iconPosition?: TButtonOption['iconPosition'], size?: TButtonOption['size']): string => {
    const prefix = size ? size.charAt(0).toUpperCase() + size.slice(1) : 'Medium';
    const postfix = hasIcon ? (iconPosition === 'right' ? 'IconRight' : 'IconLeft') : '';

    return prefix + postfix;
};
export const getBoxShadow = (position: TButtonOption['position'], hierarchy: TButtonOption['hierarchy'], disabled: boolean): string => {
    if (position === 'floating' && !disabled) {
        if (hierarchy === 'primary' || !hierarchy) {
            return 'Purple';
        }
        return 'Grey';
    }
    return '';
};
const getBackground = (hierarchy: TButtonOption['hierarchy'], viewBackground: TButtonOption['viewBackground'], disabled: boolean): string => {
    switch (hierarchy) {
        case 'secondary':
            return 'white';
        case 'tertiary':
            if (viewBackground === 'gradient') {
                return 'whiteBase';
            } else {
                return 'white';
            }
        default:
            return disabled ? 'purple16Lc' : 'purple100';
    }
};
const getColor = (hierarchy: TButtonOption['hierarchy'], viewBackground: TButtonOption['viewBackground'], disabled: boolean): string => {
    switch (hierarchy) {
        case 'secondary':
            return disabled ? 'purple_40_tr' : 'purple_100';
        case 'tertiary':
            if (viewBackground === 'gradient') {
                return 'white_base_gradient';
            } else {
                return disabled ? 'grey_40_lc' : 'black';
            }
        default:
            return disabled ? 'white_40_tr_base' : 'white_base';
    }
};

const BACKGROUND_CSS_VAR: Record<string, string> = {
    white: 'var(--color-white)',
    whiteBase: 'var(--color-white_0_tr_base)',
    purple16Lc: 'var(--color-purple_16_lc)',
    purple100: 'var(--color-purple_100)',
};

const COLOR_CSS_VAR: Record<string, string> = {
    purple_100: 'var(--color-purple_100)',
    purple_40_tr: 'var(--color-purple_40_tr)',
    white_base: 'var(--color-white_base)',
    white_base_gradient: 'var(--color-white_base)',
    grey_40_lc: 'var(--color-grey_40_lc)',
    black: 'var(--color-black)',
    white_40_tr_base: 'var(--color-white_40_tr_base)',
};

const HOVER_BG_CSS_VAR: Record<string, string> = {
    white_base: 'var(--color-purple_72_hc)',
    purple_100: 'var(--color-purple_16_lc)',
    black: 'var(--color-grey_16_lc)',
    white_base_gradient: 'var(--color-white_8_tr_base)',
    purple_40_tr: 'var(--color-white)',
    grey_40_lc: 'var(--color-white)',
    white_40_tr_base: 'var(--color-purple_16_lc)',
};

const ACTIVE_BG_CSS_VAR: Record<string, string> = {
    white_base: 'var(--color-purple_72_lc)',
    purple_100: 'var(--color-purple_8_lc)',
    black: 'var(--color-grey_8_lc)',
    white_base_gradient: 'var(--color-white_16_tr_base)',
    purple_40_tr: 'var(--color-white)',
    grey_40_lc: 'var(--color-white)',
    white_40_tr_base: 'var(--color-purple_16_lc)',
};

export const getMainColor = (hierarchy: TButtonOption['hierarchy'], viewBackground: TButtonOption['viewBackground'], disabled: boolean): string =>
    BACKGROUND_CSS_VAR[getBackground(hierarchy, viewBackground, disabled)] ?? 'transparent';

export const getOnMainColor = (hierarchy: TButtonOption['hierarchy'], viewBackground: TButtonOption['viewBackground'], disabled: boolean): string =>
    COLOR_CSS_VAR[getColor(hierarchy, viewBackground, disabled)] ?? 'inherit';

export const getHoverBgColor = (hierarchy: TButtonOption['hierarchy'], viewBackground: TButtonOption['viewBackground']): string =>
    HOVER_BG_CSS_VAR[getColor(hierarchy, viewBackground, false)] ?? 'transparent';

export const getActiveBgColor = (hierarchy: TButtonOption['hierarchy'], viewBackground: TButtonOption['viewBackground']): string =>
    ACTIVE_BG_CSS_VAR[getColor(hierarchy, viewBackground, false)] ?? 'transparent';
